import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import { translate } from 'react-i18next'

// COMPONENTS
import Spinner from '../spinner'
import customInputLine from './field/customInputLine'
import maskInput from './field/maskInput'
import { ButtonContained } from '../app-button/button'
import {
  required,
  email,
  minLength,
  asyncValidate,
  phone,
} from './validation/validation'

const styles = theme => ({
  form: {
    maxWidth: 320,
    width: '100%',
  },

  invalid: {},

  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },

  inputWrapper: {
    position: 'relative',
  },

  serverError: {
    top: '50%',
    right: 0,
    color: '#0000009a',
    position: 'absolute',
    fontSize: 16,
    transform: 'translate(100%, -50%)',
    maxWidth: 280,
    marginLeft: 20,
    fontFamily: 'Caveat',
    lineHeight: 'inherit',
    whiteSpace: 'pre-line',
    paddingLeft: 20,
    letterSpacing: 1.1,
  },
})

class RegisterForm extends Component {
  resetValueField = name => {
    this.props.change(this.props.form, name, '')
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
      errors,
      t,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div className={classes.inputWrapper}>
          <Field
            name="email"
            component={customInputLine}
            type="text"
            label={t('registration.email', { framework: 'react-i18next' })}
            validate={[required, email]}
            hint={t('registration.confirm', { framework: 'react-i18next' })}
            handleResetField={this.resetValueField}
            isAsync={true}
            focus={true}
            serverError={errors.email && errors.email[0]}
          />
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="password"
            component={customInputLine}
            type="password"
            label={t('registration.password', { framework: 'react-i18next' })}
            validate={[required, minLength]}
            hint={t('registration.passLength', { framework: 'react-i18next' })}
            handleResetField={this.resetValueField}
            serverError={errors.password && errors.password[0]}
          />
        </div>
        <div className={classes.inputWrapper}>
          <Field
            ref={ref => (this.field = ref)}
            name="phone"
            component={maskInput}
            type="text"
            label={t('registration.phone', { framework: 'react-i18next' })}
            validate={[required, phone]}
            hint={t('registration.codeRegion', { framework: 'react-i18next' })}
            handleResetField={this.resetValueField}
            serverError={errors.phone && errors.phone[0]}
          />
        </div>
        <ButtonContained
          style={{
            height: 64,
            marginTop: 30,
            fontSize: 16,
            width: '100%',
            padding: 0,
            fontWeight: 600,
          }}
          type="submit"
          color="primary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={
            isFetching ? (
              <Spinner stroke="#000000" />
            ) : (
              t('registration.btn', { framework: 'react-i18next' })
            )
          }
        />
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

RegisterForm = reduxForm({
  form: 'register',
})(
  connect(
    null,
    mapDispatchToProps
  )(RegisterForm)
)

export default withStyles(styles)(translate('common')(RegisterForm))
